import { atomWithReset } from 'jotai/utils';

import { EditSettingDrawerState, MaterialsModalState } from './types';

export const editSettingDrawerState = atomWithReset<EditSettingDrawerState>({
  isOpen: false,
  shouldScrollToBusinessHours: false,
});

export const materialsModalState = atomWithReset<MaterialsModalState>({
  isOpen: false,
});
